export default {
  API_URL: "https://photosmile.biz",
  X_API_KEY: "KB9gqI317E6xKu8JzDwHy8Scc3CpHARKch2QNILe",
  API_ENDPOINT_PREFIX_ADMIN: "api/1",
  PAYMENT: {
    KURONEKO: {
      GATEPAY: "https://payment.kuronekoyamato.co.jp/webcollect/settleSelectAction.gw",
      trader_code: "720007701",
      return_url: "https://photosmile.biz/api/1/paymentstatus",
      cancel_url: "https://photosmile.biz/complete-abnormal/{orderNo}",
      success_url: "https://photosmile.biz/complete-web/{orderNo}",
      failure_url: "https://photosmile.biz/complete-abnormal/{orderNo}",
    },
  },
  BANNER_SCHEDULES: [
    {
      from: {
        month: 8,
        day: 2,
      },
      to: {
        month: 10,
        day: 18,
      },
      url: "/images/banners/top_banner.png",
    },

    {
      from: {
        month: 10,
        day: 19,
      },
      to: {
        month: 8,
        day: 1,
      },
      url: "/images/banners/new_year_banner.jpg",
    },
  ],
};
